<template>
  <div class="records-container">
    <BattleHeader title="我的记录" @back="goBack" />

    <!-- 挑战记录列表 -->
    <main class="records-main">
      <!-- 记录列表 -->
      <div class="records-list" v-if="records.length > 0">
        <!-- 挑战记录项 -->
        <div 
          v-for="(record, index) in records" 
          :key="index"
          class="record-item"
        >
          <!-- 挑战日期 -->
          <div class="record-date">
            {{ record.date }}
          </div>

          <!-- 记录卡片 -->
          <div class="result-stats">
            <!-- 标题和副标题 -->
            <h2 class="result-subtitle">{{ record.title }}</h2>
            <p class="result-description">{{ record.subtitle }}</p>

            <!-- 统计信息 -->
            <div class="stats-grid">
              <div class="stat-item">
                <div class="stat-icon correct">
                  <i class="fas fa-check"></i>
                </div>
                <p class="stat-number correct">{{ record.correctCount }}</p>
                <p class="stat-label"> 正确 </p>
              </div>
              
              <div class="stat-item">
                <div class="stat-icon wrong">
                  <i class="fas fa-times"></i>
                </div>
                <p class="stat-number wrong">{{ record.wrongCount }}</p>
                <p class="stat-label"> 错误 </p>
              </div>
              
              <div class="stat-item">
                <div class="stat-icon time">
                  <i class="fas fa-clock"></i>
                </div>
                <p class="stat-number time">{{ record.timeType }}</p>
                <p class="stat-label"> 耗时(分) </p>
              </div>
            </div>

            <!-- 排名信息 -->
            <div class="ranking-section">
              <p class="challenge-info">在{{ record.challengeType }}中排名</p>
              <p class="ranking-display">第<span class="ranking-number">{{ record.ranking }}</span>名</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-if="records.length === 0" class="empty-state">
        <i class="empty-icon fas fa-clipboard-list"></i>
        <p class="empty-text">暂无答题记录</p>
        <button 
          @click="startNewChallenge" 
          class="start-challenge-btn"
        >
          开始挑战
        </button>
      </div>
    </main>
  </div>
</template>

<script>
import { globalAuthState, initAuthState } from '../utils/auth';
import { getRecords } from '../api/api';
import BattleHeader from '@/components/BattleHeader.vue'
export default {
  components: { BattleHeader },
  name: 'RecordsPage',
  async mounted() {
    // 初始化登录状态
    await initAuthState();
    // 检查是否有用户信息
    if (!globalAuthState.isLogin) {
      // 没有用户信息，跳转到登录页面
      this.$router.push('/login')
    }
    // 有用户信息，获取记录详情
    this.fetchRecords()
  },
  data() {
    return {
      records: [
        {
          date: '2025年11月23日 12:01',
          title: '书法大神',
          subtitle: '恭喜您完成本次挑战！',
          correctCount: 0,
          wrongCount: 0,
          timeType: 0,
          ranking: '1',
          challengeType: '5分钟挑战赛'
        }
      ]
    }
  },
  methods: {
    /**
     * 获取记录详情
     */
    fetchRecords() {
      getRecords().then(res => {
        if (res.code === 1) {
          this.records = res.data.map(item => {
            try {
              return {
                date: item.date || item.createdAt || '未知日期',
                title: item.title || '书法大神',
                subtitle: item.subtitle || '恭喜您完成本次挑战！',
                correctCount: item.correctCount || 0,
                wrongCount: item.wrongCount || 0,
                ranking: item.ranking || '0',
                timeType: item.timeType || 0,
                challengeType: item.challengeType || '5分钟挑战赛'
              };
            } catch (e) {
              console.warn('解析挑战记录失败:', e, item);
              return {
                date: item.createdAt || item.date || '未知日期',
                title: '书法大神',
                subtitle: '恭喜您完成本次挑战！',
                correctCount: 0,
                wrongCount: 0,
                ranking: '0',
                challengeType: '5分钟挑战赛'
              };
            }
          });
          console.log(this.records)
        }
      })
    },
    goBack() {
      this.$router.push('/')
    },
    startNewChallenge() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.records-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #F5F5F5;
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

.records-main {
  flex: 1;
  padding: calc(var(--battle-header-height) + 20px) 24px 24px;
  max-width: 672px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.records-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.record-item {
  transition: all 0.3s ease;
}

.record-date {
  font-size: 14px;
  color: #666666;
  margin-bottom: 8px;
  font-weight: 500;
}

/* 结果统计样式 */
.result-stats {
  background-color: white;
  border-radius: 16px;
  padding: 32px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  text-align: center;
}

.result-subtitle {
  font-size: clamp(2rem, 5vw, 3rem);
  font-weight: bold;
  color: #D54D24;
  margin-top: -10px;
  margin-bottom: 8px;
  text-align: center;
}

.result-description {
  font-size: 16px;
  color: #999999;
  margin-bottom: 32px;
  text-align: center;
}

.stats-grid {
  display: flex;
  justify-content: space-around;
  gap: 20px;
  margin-bottom: 32px;
}

.stat-item {
  text-align: center;
  flex: 1;
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  font-size: 24px;
}

.stat-icon.correct {
  background-color: rgba(16, 185, 129, 0.1);
  color: #10B981;
}

.stat-icon.wrong {
  background-color: rgba(239, 68, 68, 0.1);
  color: #EF4444;
}

.stat-icon.time {
  background-color: rgba(59, 130, 246, 0.1);
  color: #3B82F6;
}

.stat-number {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 4px;
}

.stat-number.correct {
  color: #10B981;
}

.stat-number.wrong {
  color: #EF4444;
}

.stat-number.time {
  color: #3B82F6;
}

.stat-label {
  color: #999999;
  font-size: 12px;
  margin: 0;
}

.ranking-section {
  background-color: #F8F8F8;
  border-radius: 12px;
  padding: 24px;
  text-align: center;
}

.challenge-info {
  color: #999999;
  font-size: 14px;
  margin-bottom: 16px;
  text-align: center;
}

.ranking-display {
  font-size: 28px;
  font-weight: bold;
  color: #333333;
  margin: 0;
}

.ranking-number {
  color: #D54D24;
  font-size: 48px;
}

.empty-state {
  text-align: center;
  padding: 60px 24px;
  color: #999999;
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-text {
  font-size: 16px;
  margin-bottom: 24px;
}

.start-challenge-btn {
  background-color: #D54D24;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.start-challenge-btn:hover {
  background-color: #C2410C;
}
</style>
